var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRoundedWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38667 0 0 5.38667 0 12C0 18.6133 5.38667 24 12 24C18.6133 24 24 18.6133 24 12C24 5.38667 18.6133 0 12 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3067 7.69338C16 7.38671 15.4534 7.38671 15.1467 7.69338L12 10.84L8.85337 7.69338C8.5467 7.38671 8.00004 7.38671 7.69337 7.69338C7.37337 8.01338 7.37337 8.53338 7.69337 8.85338L10.84 12L7.69337 15.1467C7.37337 15.4667 7.37337 15.9867 7.69337 16.3067C8.00004 16.6134 8.5467 16.6134 8.85337 16.3067L12 13.16L15.1467 16.3067C15.3067 16.4667 15.5067 16.5467 15.72 16.5467C15.9334 16.5467 16.1467 16.4667 16.2934 16.3067C16.6134 15.9867 16.6134 15.4667 16.2934 15.1467L13.1467 12L16.2934 8.85338C16.6134 8.53338 16.6134 8.01338 16.2934 7.69338H16.3067Z",
    fill: "#04A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundedWhiteIcon);
export default __webpack_public_path__ + "static/media/CloseRoundedWhiteIcon.ee8382d05c82a1ba850b5739c83aac73.svg";
export { ForwardRef as ReactComponent };